var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20"},[_c('ChooseCategoryBlock',_vm._b({},'ChooseCategoryBlock',_vm.chooseCategoryBlockProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }